import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@99designs/common/components/Button';

function signupUrlWithRedirectTarget(url) {
    return `${url}&target=${encodeURIComponent(`${location.pathname}${location.search}`)}`;
}

function SignUpCta({ signUpCtaUrl }) {
    return (
        <div className="product-cta-interjection">
            <div className="product-cta-interjection__text">
                <h5 className="heading heading--heritage heading--size5 heading--no-margin">
                    <FormattedMessage id="product_interjection_heading" />
                </h5>
                <h6 className="paragraph paragraph--root paragraph--large paragraph--no-margin">
                    <FormattedMessage id="product_interjection_text" />
                </h6>
            </div>
            <div className="product-cta-interjection__cta">
                <Button
                    href={signupUrlWithRedirectTarget(signUpCtaUrl)}
                    variations={['primary', 'jumbo', 'responsive', 'chameleon']}
                >
                    <FormattedMessage id="product_interjection_button" />
                </Button>
            </div>
        </div>
    );
}

SignUpCta.propTypes = {
    signUpCtaUrl: PropTypes.string.isRequired,
};

export default SignUpCta;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/SignUpCta.jsx